import { render, staticRenderFns } from "./BookingHeader.vue?vue&type=template&id=0ba60f46&scoped=true"
import script from "./BookingHeader.vue?vue&type=script&lang=js"
export * from "./BookingHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba60f46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ba60f46')) {
      api.createRecord('0ba60f46', component.options)
    } else {
      api.reload('0ba60f46', component.options)
    }
    module.hot.accept("./BookingHeader.vue?vue&type=template&id=0ba60f46&scoped=true", function () {
      api.rerender('0ba60f46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/booking/BookingHeader.vue"
export default component.exports